module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "management"
    }
  }, [_h('h4', [_h('center', ["当前为管理清单分类页，暂未完成"])]), " ", _h('ul', [_vm._l((_vm.items), function(item) {
    return _h('li')
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe6a5d6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage.vue
// module id = 49
// module chunks = 1